const css = require('./personal.css');
const UserForm = require('../common/user/user-form');
const PasswordChange = require('./password-change');

class Personal {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: Personal,
    children: [
        {
            name: 'user-form',
            component: UserForm,
            watcher: {
                userType: ['account', 'userForm', 'form', 'userType']
            }
        },
        {
            name: 'password-change',
            component: PasswordChange,
            watcher: {
                isEnabled: ['account', 'passwordChangeForm', 'computed', 'isEnabled'],
                passwordChanged: ['account', 'passwordChangeForm', 'passwordChanged'],
                result: ['account', 'passwordChangeForm', 'result']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/personal/index.js